import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { DoubleBounceComponent } from './shared/spinners/double-bounce/double-bounce.component';
import { CustomAlertComponent } from './shared/custom-alert/custom-alert.component';
import { BrowserAnimationsModule  } from '@angular/platform-browser/animations';
import { BrowserXhr } from '@angular/http';

// primeng modules
import { DialogModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import {DataTableModule,SharedModule,PaginatorModule} from 'primeng/primeng';

// Custom Pipes
import { FillPipe } from './shared/fill.pipe';

import { MomentModule } from 'angular2-moment';

import { NgProgressModule, NgProgressBrowserXhr } from 'ngx-progressbar';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BrowserAnimationsModule,
    NgProgressModule,
    MomentModule,
    DataTableModule,SharedModule,PaginatorModule,DialogModule,AutoCompleteModule, CalendarModule
  ],
  declarations: [    
      BreadcrumbsComponent,
      DoubleBounceComponent,
      CustomAlertComponent,
      FillPipe, 
  ],
  providers:[
    { provide: BrowserXhr, useClass: NgProgressBrowserXhr},
  ],
  exports: [
        BreadcrumbsComponent,
        DoubleBounceComponent,
        CustomAlertComponent,
        FillPipe,
        NgProgressModule,
        BrowserAnimationsModule,
        MomentModule,
        DataTableModule,SharedModule,PaginatorModule,DialogModule,AutoCompleteModule, CalendarModule
  ]
})
export class BaseModule { }



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/shared.module.ts